import { DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default objectDuckCreator({
    ...srpDuckPreset,
    store: 'redirectPage',
}).extend({
    selectors: () => ({
        getRedirectExpiredPage: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).redirectExpiredPage),
    }),
});
